import { ReactNode } from 'react';

import ArrotBack from '../../assets/img/blue_icon-arrow-left.svg';
import ClickableImage from '../ClickableImage/ClickableImage';

import styles from './BaseModalMobile.module.scss';

type Props = {
  children: ReactNode;
  onClose: () => void;
  isOpen: boolean;
};

const BaseModalMobile = (props: Props) => {
  const { children, onClose, isOpen } = props;

  return (
    <>
      {isOpen && (
        <div className={styles.background}>
          <div className={styles.container}>
            <div className={styles.arrowBack}>
              <ClickableImage src={ArrotBack} onClick={onClose} />
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default BaseModalMobile;
